import { AnyError } from '@futrli/errors';
import { FormattedMessage } from '@futrli/localisation';
import React from 'react';

import { get, isArray } from 'lodash';

export const DEFAULT_ERROR_FORM_MESSAGE = "Sorry, there's a problem! Please check your details and try again.";
export const DEFAULT_ERROR_FORM_MESSAGE_ID = 'common.sorry_problem';

/**
 * @TODO Tech debt - We need to have the errors coming from BE in the same format and with a field identifier or slug,
 * if we wanna show them properly under each textfield.
 * This method will be removed at that point.
 * @see https://crunchboards.atlassian.net/browse/FUT-6011
 *
 * Chargebee errors are coming as an array of strings.
 * Stripe errors are coming as an object with code and message property
 *
 * @param {AnyError} error
 * @returns {JSX.Element}
 */
export const getFormError = (error: AnyError): JSX.Element => {
  const errorData = get(error, 'response.data');
  let message = isArray(errorData) ? errorData[0] : get(errorData, 'message');

  if (!message && isStripeAPIError(error)) {
    message = get(error, 'message');
  }

  if (!message) {
    return (
      <FormattedMessage
        id="common.sorry_problem"
        defaultMessage="Sorry, there's a problem! Please check your details and try again."
      />
    );
  }

  return <React.Fragment>{message}</React.Fragment>;
};

/**
 * Determines if the error is coming from Stripe API or is coming from our API.
 * @param {AnyError} error
 * @returns {JSX.Element}
 *
 * @FIXME Tech-debt: This will need to be reworked when
 * @see https://crunchboards.atlassian.net/browse/FUT-6011
 * is finished.
 */
export function isStripeAPIError(error: AnyError): boolean {
  return get(error, 'code') !== undefined;
}
